import { UseBaseQueryOptions, useQuery } from '@tanstack/react-query'
import { TagsQueryKeys } from '../../constants'
import { GetPlayersByTagResponse, GetPlayersByTagsRequest } from '../../types'
import { getPlayersByTags } from '../services'

export default function useQueryGetPlayersByTags(
	params?: GetPlayersByTagsRequest,
	props?: UseBaseQueryOptions<GetPlayersByTagResponse>,
) {
	return useQuery({
		queryKey: [TagsQueryKeys.GetPlayersByTags, params],
		queryFn: () => getPlayersByTags(params),
		...props,
	})
}
